import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {getSnapshot} from 'mobx-state-tree';
import {AppFeedback, AppNotification, AppMessage} from '../../models/appFeedbackModel';
import Notifications, {NotificationsProps, NotificationProps} from '../../components/Notifications';
import Messages, {MessagesProps, MessageProps} from '../../components/Messages';

interface WithInjectedProps {
  appFeedback: AppFeedback;
}

@inject('appFeedback')
@observer
export default class AppNotificationsContainer extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Notifications {...this._notificationsProps} />
        <Messages {...this._messagesProps} />
      </React.Fragment>
    );
  }

  private get _notificationsProps(): NotificationsProps {
    return {
      notifications: this._withInjectedProps.appFeedback.notifications.map(e =>
        getSnapshot(e as AppNotification)
      ) as NotificationProps[],
      onClose: this._handleCloseNotification
    };
  }

  private get _messagesProps(): MessagesProps {
    return {
      messages: this._withInjectedProps.appFeedback.messages.map(e => getSnapshot(e as AppMessage)) as MessageProps[],
      onClose: this._handleCloseNotification
    };
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _handleCloseNotification = (notification: NotificationProps | MessageProps) => {
    this._withInjectedProps.appFeedback.remove(notification as AppNotification | AppMessage);
  };
}



// WEBPACK FOOTER //
// ./src/containers/AppNotificationsContainers/AppNotificationsContainer.tsx